import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/constants';

interface AppInfo {
  name: string;
  version: string;
}

export const useAppInfo = () => {
  const [appInfo, setAppInfo] = useState<AppInfo>({ 
    name: 'CompassAI Studio', 
    version: '2.0.0' 
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAppInfo = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/app-info`);
        if (response.ok) {
          const data = await response.json();
          setAppInfo(data);
        }
      } catch (error) {
        console.warn('Failed to fetch app info, using defaults:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAppInfo();
  }, []);

  return { appInfo, loading };
};